export function applyValidation(errors, keys) {
    resetValidation(keys)

    for (let error in errors) {
        const el = document.getElementById(error)

        if (el) {
            el.style.borderColor = 'red'

            let div = document.createElement('div');
            div.id = `${error}-error`;

            for (let e of errors[error]) {
                let p = document.createElement('p');
                p.className = 'mt-2 text-sm text-red-600 first-letter:uppercase'
                p.innerText = e;
                div.appendChild(p);
            }

            if (['url'].includes(error)) {
                el.parentNode.parentNode.append(div);
            } else {
                el.parentNode.append(div);
            }
        }
    }
}

export function resetValidation(keys) {
    keys.forEach(key => {
        const input = document.getElementById(key)
        if (input) {
            input.style.borderColor = ''
        }

        const validationMessage = document.getElementById(`${key}-error`)
        if (validationMessage) {
            validationMessage.remove()
        }
    })
}
